import { render } from "./financesMenu.vue?vue&type=template&id=2d966c42"
import script from "./financesMenu.vue?vue&type=script&lang=js"
export * from "./financesMenu.vue?vue&type=script&lang=js"

import "./financesMenu.vue?vue&type=style&index=0&id=2d966c42&lang=css"

import exportComponent from "/var/www/public_web/selllogix-vuecli/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__